import React from 'react';
import { gql } from '@apollo/client';
import { AdminEntityMergeRequestItemProps } from '../../AdminEntityMergeRequestItem';
import {
  EntityTypeEnum,
  MergeItemSiteAddressFragment,
} from '../../../../../../../../../gql/typings';
import AdminMergeItemAddress, { mergeAddress_FRAGMENT } from '../../shared/Address/AdminMergeItemAddress';

const AdminMergeItemSiteAddress: React.FC<AdminEntityMergeRequestItemProps> = (props) => {
  const info = props.item.type as MergeItemSiteAddressFragment;

  return (
    <AdminMergeItemAddress
      {...props}
      entityType={EntityTypeEnum.SITE}
      addressAffiliation={info.addressAffiliation}
      conflictedAddressAffiliation={info.conflictedWith}
    />
  );
};

gql`
  fragment MergeItemSiteAddress on SiteAddress_EntityDataToBeTransferredType {
    code
    addressAffiliation { ...MergeAddress }
    conflictedWith { ...MergeAddress }
  }
  
  ${mergeAddress_FRAGMENT}
`;

export default AdminMergeItemSiteAddress;
